import React, { Fragment, useState } from "react";
import { Field } from 'formik';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
import TimeField from 'react-simple-timefield';
export default ({ name,  disabled, locationState, startTime, endTime, props, fromValue, toValue}) => {
    let currentDate = new Date()
    let setTimeVal = '08:00'

    if (name === "bidTime"){
        let setState = locationState;
        let nDate;
        if (setState === "California" || setState === "California ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Los_Angeles").format('HH:mm');
        }
        else if (setState === "Alaska" || setState === "Alaska ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("US/Alaska").format('HH:mm');
        } else if (setState === "American Samoa") {
            const moment = require('moment-timezone');
            nDate = moment().tz("American/American Samoa").format('HH:mm');
        } else if (setState === "Washington") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Washington").format('HH:mm');
        }
        else if (setState === "Arizona") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Phoenix").format('HH:mm');
        }
        else {
            nDate = new Date().toLocaleString('en-US', {
                timeZone: 'US/' + timeZoneFun(setState)
            });
            let getTime = new Date(nDate)
            let setHours = getTime.getHours()
            let setMinutes = getTime.getMinutes()
            if (setHours.toString().length === 1) {
                setHours = '0' + setHours
            }
            if (setMinutes.toString().length === 1) {
                setMinutes = '0' + setMinutes
            }
            nDate = setHours + ':' + setMinutes
        }
        setTimeVal = nDate
    }

    if (name === "requestedStartTime" && startTime === null){
        currentDate.setHours(8)
        currentDate.setMinutes(0)
        setTimeVal = '08:00'
    }
    if (name === "requestedStartTime" && startTime !== null) {
        let setbidTimeArr = startTime.split(':')

        let setHours = setbidTimeArr[0]
        let setMinutes = setbidTimeArr[1]
        if (setbidTimeArr[0].length === 1) {
            setHours = 0 + setbidTimeArr[0]
        }
        if (setbidTimeArr[1].length === 1) {
            setMinutes = 0 + setbidTimeArr[1]
        }
        setTimeVal = setHours + ':' + setMinutes
    }

    if (name === "requestedEndTime" && endTime === null) {
        currentDate.setHours(17)
        currentDate.setMinutes(0)
        setTimeVal = '17:00'
    }   

    if (name === "requestedEndTime" && endTime !== null) {
        let setbidTimeArr = endTime.split(':')

        let setHours = setbidTimeArr[0]
        let setMinutes = setbidTimeArr[1]
        if (setbidTimeArr[0].length === 1) {
            setHours = 0 + setbidTimeArr[0]
        }
        if (setbidTimeArr[1].length === 1) {
            setMinutes = 0 + setbidTimeArr[1]
        }
        setTimeVal = setHours + ':' + setMinutes
    }

    const [selectedTime, handleTimeChange] = useState();
    if (disabled === undefined) disabled = false;
    const changeHandler = (name, setFieldValue, setFieldError, time) => {
        let setTime = time.target.value;
        let dateSet = new Date();
        let selectedTime = new Date(`1970-01-01T${setTime}`);

        if (selectedTime <= new Date(`1970-01-01T00:00`)) {
            setFieldError(name, "Please enter valid Time.");
        } else {
            if (name === "bidTime") {
                handleTimeChange(setTime);
                setFieldValue(name, setTime);
            } else{
                if (name === "requestedStartTime" || name === "requestedEndTime") {
                    if (props.values.requestedStartTime === setTime || setTime === props.values.requestedEndTime) {
                    } else {
                        handleTimeChange(setTime);
                        setFieldValue(name, setTime);
                    }
                } else {
                    if (dateSet <= setTime) {
                        handleTimeChange(setTime);
                        setFieldValue(name, setTime);
                    } else {
                        if (fromValue || toValue) {
                            setFieldValue(name, setTime);
                        } else {
                            setFieldError(name, "Cannot select less time");
                        }
                    }
                }
            }            
        }
    }

    return (
        <div>
            <Field name={name}>
                {({ field, form, meta }) => {
                    return (
                        <Fragment>
                            <div className='custom-date-piker'>
                                <div
                                    className={`app-input-text ${meta.touched && meta.error ? 'error' : ''
                                    }`}
                                >
                                    <TimeField
                                        disabled={disabled}
                                        className='s-input -time'
                                        name={name}
                                        value={selectedTime ? selectedTime :
                                            setTimeVal}
                                        onChange={(time) => {
                                            changeHandler(name, form.setFieldValue, form.setFieldError, time)
                                        }} />
                                </div>

                            </div>
                            {meta.error && <p name={name} className="error-message">{meta.error}</p>}
                        </Fragment>
                    );
                }}
            </Field>

        </div>
    );
};